module.exports = __webpack_public_path__ + "7dff061a23555f9ffc4e8341f8dca31d.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_xlarge_x1/public/games/coh_image_1.jpg
// module id = 500
// module chunks = 0